import React from "react";
import "../../../css/gardenManagerStylings/GardenExportViewStyling.css";
import DashboardGardenGrid from "../../dashboardComponents/DashboardGardenGrid";
import logo from '../../../images/animatedLogo/finalLogoSVG.svg';

const GardenExportView = React.forwardRef(({ garden, isMobile, config }, ref) => {
    if (!garden) return null;

    const {
        title = garden.name || "My Garden Plan",
        subtext = "My Garden Plan",
        showTitle = true,
        showSubtext = true,
        showFooter = true,
        showWatermark = true,
        showBackground = true,
        showGradientBackground = true,
        logoPosition = 'bottom-right',
        titleAlignment = 'left',
        subtextAlignment = 'right'
    } = config || {};

    return (
        <div className={`garden-export-wrapper ${!showGradientBackground ? 'no-bg' : ``}`} ref={ref}>
            {showTitle && (
                <div
                    className="export-title"
                    style={{ textAlign: titleAlignment }}
                >
                    {title}
                </div>
            )}

            <div className="export-planter-garden-image">
                <DashboardGardenGrid
                    gardenMatrix={garden.matrix}
                    plants={garden.plants}
                    gardenManager={true} // set to false to avoid hover state
                    isMobile={isMobile}
                    background={showBackground}
                />
            </div>

            {showSubtext && (
                <div
                    className="export-subtext"
                    style={{ textAlign: subtextAlignment }}
                >
                    {subtext}
                </div>
            )}

            {showFooter && (
                <div className="export-footer">
                    <div className={`footer-divider`}></div>
                    <div className={`footer-text`}>myplantedgarden.com</div>
                    <div className={`footer-divider`}></div>
                </div>
            )}

            {showWatermark && (
                <img
                    src={logo}
                    alt="Watermark"
                    className={`export-watermark ${logoPosition}`}
                />
            )}
        </div>
    );
});

GardenExportView.displayName = 'GardenExportView';

export default GardenExportView;